import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { DeviceId } from '@shared/models/device';
import { LoRaWANDevicePoint, LoRaWANPointFormat, LoRaWANPointType } from '@shared/models/lorawan';
import { DevicesService } from '@core/services/devices.service';
import { DrawerHeightFromBottomComponent } from '../../drawer-height-from-bottom/drawer-height-from-bottom.component';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { PillComponent } from '../../pill/pill.component';

@Component({
  selector: 'motn-lorawan-single-point',
  templateUrl: './lorawan-single-point.component.html',
  styleUrls: ['./lorawan-single-point.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DrawerHeightFromBottomComponent, FormsModule, NgClass, SpinnerComponent, PillComponent],
})
export class LoRaWANSinglePointComponent implements OnInit {
  @Input() point: LoRaWANDevicePoint | null = null;
  @Input() deviceId: DeviceId;

  @Output() clickedOutside$ = new EventEmitter<void>();
  @Output() saved$ = new EventEmitter<void>();

  LoRaWANPointType = LoRaWANPointType;
  LoRaWANPointFormat = LoRaWANPointFormat;

  name = '';
  type = LoRaWANPointType.UplinkPayload;
  format = LoRaWANPointFormat.Numeric;
  saving = false;

  constructor(private devicesService: DevicesService) {}

  ngOnInit() {
    if (this.point) {
      this.name = this.point.ID[1];
      this.type = this.point.ID[0];
      this.format = this.point.ID[2];
    }
  }

  save() {
    if (!this.name.trim()) return;
    this.saving = true;

    const updated: LoRaWANDevicePoint = {
      ID: [this.type, this.name.trim(), this.format],
    };

    this.devicesService.saveLoRaWANPoint$(updated, this.deviceId, this.point).subscribe({
      next: () => {
        this.saving = false;
        this.saved$.emit();
      },
      error: () => {
        this.saving = false;
      },
    });
  }
}
